const routes = [
    {
        path: "/university/courses",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "universitycourse_index"
        }
    }
];

export default routes;
